const { default: common } = require('./common')
const { default: dialog } = require('./dialog')
const { default: gallery } = require('./gallery')
const { default: page } = require('./page')
const { default: playback } = require('./playback')
const { default: region } = require('./region')
const { default: selectmenu } = require('./selectmenu')
const { default: selectpage } = require('./selectpage')
const { default: suggest } = require('./suggest')
const { default: upload } = require('./upload')

module.exports = {
  common,
  page,
  region,
  dialog,
  upload,
  selectpage,
  suggest,
  playback,
  selectmenu,
  gallery
}
